<div mat-dialog-title>
  <div class="card-dlg-title">
    <p>Histórico de incentivos</p>
    <mat-icon mat-dialog-close (click)="dialogRef.close()">close</mat-icon>
  </div>
</div>

<mat-divider></mat-divider>

<div class="card-dlg mat-typography">
  <div class="card-dlg__wrapper">
    @if (incentiveHistory.length === 0 && !isLoading) {
      <div class="card-dlg--empty">
        <p>Nenhum histórico de incentivo encontrado para esta unidade.</p>
      </div>
    }

    @for (item of incentiveHistory; track item.title) {
      <div class="history-item">
        <p class="history-item__title">{{ item.title }}</p>
        <div class="history-item__wrapper">
          <div class="history-item__box">
            <p>Data de vigência</p>
            <h4><strong> {{ item.startDate | date:'dd/MM/yyyy' }}
              - {{ item.endDate | date:'dd/MM/yyyy' }}</strong></h4>
          </div>

          <div class="history-item__box">
            <p> Quantidade entregue</p>
            <h4><strong>{{ item.totalOfDrawsDelivered }}/{{ item.totalOfDrawsInPeriod }} </strong></h4>
          </div>

        </div>
      </div>

      @if (!$last) {
        <mat-divider></mat-divider>
      }
    }
  </div>
</div>
